import { Template } from './../masterdata/models/template';
import { BBResponseContainer } from './../carrier/response-container';
import { Channel } from "./../agptesting-newview/model/channel";
import {
  ResultViewDTO,
  SampleResultViewDTO,
  ShipToSenderDTO,
} from "./ship-To-Sender";
import { Component, OnInit } from "@angular/core";
import * as jwt_decode from "jwt-decode";
import { ConfirmationService, SelectItem } from "primeng/api";
import {
  Covid19Batch,
  WellType,
} from "../agptesting-newview/model/covid19Batch";
import { AuthUtil } from "../common-services/auth-util";
import { MessagesService } from "../messages/messages.service";
import { ErrorHandler } from "../utils/error-handler";
import { APGAdministrationService } from "./apg-administration.service";
import { Comment } from "../agptesting-newview/model/comment";
import { MasterDataService } from "../masterdata/masterdata.service";
import { LabMDM } from "../masterdata/models/lab";
import { SampleHistoryTable } from "../models/sample-history-table";
import { Covid19Pool } from "../models/covid19-pool";
import { Covid19SuperPool } from "../models/covid19-superPools";
import { Covid19SuperPoolView } from "../models/covid19-superPools-view";
import { Covid19SuperPoolSampleInfoView } from "../models/covid19-superPool-sample-info-view";
import { BatchGroup } from "../agptesting-newview/model/batchGroup";
import { Covid19PoolSampleInfo } from '../models/covid19-pool-sample-info';
import { Printer } from "../masterdata/models/printer";
import { WorkFlow } from '../masterdata/models/workFlow';
import { NCSample } from '../models/nc-sample';
import { ProblemDTO } from './../masterdata/models/problem';
import { NCSaveDTO } from "../models/nc-save-response";
import { BoxDetails } from './../apg-deliver-box-manager/boxDetails';
import { Falcon } from '../models/depoolingRetestDTO';

@Component({
  selector: "app-apg-administration",
  templateUrl: "./apg-administration.component.html",
  styleUrls: ["./apg-administration.component.css"],
})
export class ApgAdministrationComponent implements OnInit {
  poolArray: string[];
  sampleSource: string;
  barcode: string;
  myMap = new Map();
  searchSelection = "batch";
  showNcSample: boolean = false;
  newimages: any[] = [];
  selectedLabId: string;
  searchedBatch: Covid19Batch;
  searchSuccess = false;
  selectedResetStatus: string;
  locked: boolean;
  rushSample: boolean;
  expectedLastPrintValue: string;
  samples: NCSample;
  selectedProblems: ProblemDTO[];
  rescueSelected: boolean = false;
  processSelected: boolean = false;
  removeSelected: boolean = false;
  ncSampleCreate: NCSample;
  ncSaveObject: NCSaveDTO;
  isNCSamplePopup: boolean;
  samplesBatchID: string;
  unBoxedSamples: any[];
  //New Lab Instance
  readonly blueberryAPGUKTeddingtonBatchActionUsers = "BlueberryAPGUK-TeddingtonBatchActionUsers";
  readonly blueberryAPGUKTeddingtonLabUsers = "BlueberryAPGUK-TeddingtonLabUsers";

  readonly blueberryAPGBatchAction = "BlueberryAPGBatchActionUsers";
  readonly blueberryAPGEBEUser = "BlueberryAPGEbersbergLabUsers";
  readonly blueberryDenmarkUser = "BlueberryAPGDenmarkLabUsers";
  readonly blueberryDenmarkBatchAction = "BlueberryAPGDenmarkBatchActionUsers";

  readonly blueberryNetherlandsUser = "BlueberryAPGNederlandLabUsers";
  readonly blueberryCPHUser = "BlueberryAPGCopenhagenLabUsers";
  readonly blueberryNetherlandsBatchAction =
    "BlueberryAPGNederlandBatchActionUsers";
  readonly blueberryCPHBatchAction = "BlueberryAPGCopenhagenBatchActionUsers";
  readonly blueberryCologneUser = "BlueberryAPGCologeneLabUsers";
  readonly blueberryCologneBatchAction = "BlueberryAPGCologeneBatchActionUsers";
  readonly blueberrySwedenUser = "BlueberryAPGSwedenUppsalaLabUsers";
  readonly blueberryswedenBatchAction =
    "BlueberryAPGSwedenUppsalaBatchActionUsers";
  readonly blueberryBirchwoodUser = "BlueberryAPGUKBirchwoodLabUsers";
  readonly blueberryBirchwoodBatchAction = "BlueberryAPGUKBirchwoodBatchActionUsers";
  readonly blueberrySilverstoneUser = "BlueberryAPGUKSilverstoneLabUsers";
  readonly blueberrySilverstoneBatchAction = "BlueberryAPGUKSilverstoneBatchActionUsers";
  readonly blueberryAustraliaUser = "BlueberryAPGAustraliaLabUsers";
  readonly blueberryAustraliaBatchAction = "BlueberryAPGAustraliaBatchActionUsers";

  validRole: boolean;
  mapOfStatusCalls = new Map();
  puid: string;
  blocked = false;
  sampleSearch: boolean = false;
  sampleInfo: any;
  showCommentDialog = false;
  showResultDialog = false;
  sampleType: string = "Sample";
  commentsMap = new Map<string, Comment[]>();
  batchCommentVisibility: Map<string, boolean>;
  batchID: string;
  batchIdPopup: boolean = false;
  batchIdToDeleteSample: string;
  redoReasonsPopup: boolean = false;
  selectedRedoReason: string;
  enteredRedoReason: string;
  selectedRedoStep: string;
  redoReasons: any[];
  destination: string = "";
  statusSelectionList = [
    { label: 'Scan Complete', value: 'SCAN_COMPLETE' },
    { label: 'Start Clipping', value: "START_CLIPPING" },
    { label: 'Complete Clipping', value: "COMPLETE_CLIPPING" },
    { label: 'Verify Reception', value: "SAMPLE_RECEPTION_CHECKED" },
    { label: 'Start Lysis', value: "START_LYSIS" },
    { label: 'Complete Lysis', value: "COMPLETE_LYSIS" },
    { label: 'Start Extraction', value: "START_EXTRACTION" },
    { label: 'Start Extractor', value: "START_EXTRACTOR" },
    { label: 'Complete Extraction', value: "EXTRACTION_COMPLETE" },
    { label: 'Merge Started', value: "MERGE_STARTED" },
    { label: 'Merge Complete', value: "MERGE_COMPLETE" },
    { label: 'Start Precycling', value: "START_PRECYCLING" },
    { label: 'Complete Precycling', value: "COMPLETE_PRECYCLING" },
    { label: 'Start Cycling', value: "START_CYCLING" },
    { label: 'Complete Cycling', value: "CYCLER_COMPLETE" },
    { label: 'Start Analysis', value: "ANALYSIS_STARTED" },
    { label: 'Complete Analysis', value: "ANALYSIS_DONE" },
    { label: 'Data Ready', value: "DATA_READY" },
    { label: 'Result File Sent', value: "COMPLETED" },
    { label: 'Redo', value: "REDO" },
    { label: 'Archive Defined', value: "ARCHIVE_DEFINED" },
    { label: 'Archived', value: "ARCHIVED" },
    { label: 'Complete Incubation', value: "COMPLETE_INCUBATION" },
    { label: 'ChaoticPooling Complete', value: "CHAOTICPOOLING_COMPLETE" },
    { label: 'Duplicate Wait', value: "DUPLICATE_WAIT" },
    { label: 'Preparation Completed', value: "PREPARATION_COMPLETED" },
    { label: 'Archive Picking Ongoing', value: "ARCHIVE_PICKING_ONGOING" },
    { label: 'Depooling Ongoing', value: "DEPOOLING_ONGOING" },
    { label: 'Archive Transfered', value: "ARCHIVE_TRANSFERED" },
    { label: 'Archive Picked', value: "ARCHIVE_PICKED" }
  ];

  errorHandler: ErrorHandler = new ErrorHandler();
  removeUnnecessaryPopup: boolean = false;
  parentBatches: string[];
  selectedBatchIdToComplete: string;
  statusListWithArchive: any[];
  selectedLab: LabMDM;
  shipToSenderDTO: ShipToSenderDTO;
  resultView: ResultViewDTO;
  sampleResultView: SampleResultViewDTO;

  samplePosition = "";

  columnHeaders384 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
  ];
  rowHeaders384 = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
  ];

  tables: SampleHistoryTable[] = [];
  sampleHistory: any;
  reset: any;
  superRush: boolean;

  redoStepList = [
    { label: 'Redo PCR', value: 'Redo_PCR' },
    { label: 'Redo Lysis', value: 'Redo_Lysis' }
  ];
  pcrKitRedoInfoForBatch: any;
  selectedRedoReasonInfo: string;
  redoChannelList: any[] = [];
  askForChannelDisabled: boolean;

  redoChannel: string;
  noRedoReasonConfiguredForLab: boolean = false;
  redoReasonsForLab: any[];
  selectedRedoReasonStep: string;
  selectedRedoReasonChannel: Array<string>;

  poolSearch: boolean = false;
  preperationPoolSearch: boolean = false;
  chaotincPoolSearch: boolean = false;

  poolNewSearch: boolean = false;
  poolSearchId: any = "";
  chaoticPoolSearchId: any = "";
  covid19PoolsToBeDisplayed: Covid19Pool[] = [];
  covid19SuperPoolsToBeDisplayed: Covid19SuperPool;
  covid19SuperPoolsToBeDisplayedView: Covid19SuperPoolView;
  covid19SuperPoolSampleInfoView: Covid19SuperPoolSampleInfoView;
  mapOfcovid19Pools = new Map();
  pooledSamplesMaxSize: number;
  batchHistory: Array<SelectItem> = [];
  groupedBatches: Array<BatchGroup> = [];
  uniqueSampleSenders: Set<string> = new Set();
  batchSenderNames: string = '';
  sampleInformation: any;
  completeBtn: string[] = ['SCAN_COMPLETE', 'EXTRACTION_COMPLETE', 'ANALYSIS_STARTED', 'CYCLER_COMPLETE'];
  showBarcodePrinting: boolean = false;
  selectedTemplate: Template;
  printer: Printer;
  printerList: Array<Printer>;
  templateList: Array<Template>;
  barcodeCount: number;
  ncBarcode: string;
  ncboxId: string;
  workFlow: WorkFlow[];
  workFlowDropDwon: SelectItem[] = [];
  selectedWorkFlow: string = null;
  isUpdateWorkflowBtnDisabled: boolean;
  isResetWorkflowDropdownReadOnly: boolean;
  boxShortInfo: BoxDetails;
  falconSampleSearch: boolean = false;
  bagIdSampleSearch: boolean = false;
  boxIdSampleSearch: boolean = false;
  depoolingRetestDTO: Falcon;
  depoolingRetestList: Falcon[];
  editUnwrappedSamplePopup: boolean;
  updatedDepoolingRetestDTO: Falcon;
  sampleHistoryInformationDto: any;
  sampleResults: any[];
  viewAnalysisBatchResults: any[];
  firstAnalysisBatchResults: any[];
  primarySampleResult1: string;
  primarySampleResult2: string;
  secondarySampleResult1: string;
  secondarySampleResult2: string;
  singleSampleRedoCount: number;
  channelAssosiatedToDisease: any[];
  channelAssociate: any[];

  sampleAllHistory: any[] = [];
  sourceBatchListDetails: any[] = [];
  analysisBatchListDetails: any[] = [];

  cols = [
    { field: 'sourceBatch', header: 'Source Batch' },
    { field: 'sourcePosition', header: 'Source Position' },
    { field: 'analysisBatch', header: 'Analysis Batch' },
    { field: 'analysisPosition', header: 'Analysis Position' },
    { field: 'rtpcrKit', header: 'RT-PCR Kit' }
  ]


  constructor(
    private _messagesService: MessagesService,
    private confirmationService: ConfirmationService,
    private apgAdminService: APGAdministrationService,
    private masterDataService: MasterDataService
  ) { }

  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem("lab")).lab._id;
    this.puid = localStorage.getItem("PUID");
    this.validRole = this.decideIfBBRoleExists();
    this.reset = [{}];
    this.mapOfStatusCalls.set("START_CLIPPING", "resetStartClipping");
    this.mapOfStatusCalls.set("COMPLETE_CLIPPING", "resetCompleteClipping");
    this.mapOfStatusCalls.set("START_LYSIS", "resetStartLysis");
    this.mapOfStatusCalls.set("COMPLETE_LYSIS", "resetCompleteLysis");
    this.mapOfStatusCalls.set(
      "SAMPLE_RECEPTION_CHECKED",
      "resetSampleReceptionChecked"
    );
    this.mapOfStatusCalls.set("START_EXTRACTION", "resetStartExtraction");
    this.mapOfStatusCalls.set("EXTRACTION_COMPLETE", "resetExtractionComplete");
    this.mapOfStatusCalls.set("START_CYCLING", "resetStartCycling");
    this.mapOfStatusCalls.set("CYCLER_COMPLETE", "resetCyclerComplete");
    this.mapOfStatusCalls.set("ANALYSIS_STARTED", "resetAnalysisStarted");
    this.mapOfStatusCalls.set("ANALYSIS_DONE", "resetAnalysisDone");
    this.mapOfStatusCalls.set("COMPLETED", "resetResultFileSent");
    this.mapOfStatusCalls.set("START_PRECYCLING", "resetStartPreCycling");
    this.mapOfStatusCalls.set("COMPLETE_PRECYCLING", "resetCompletePreCycling");
    this.mapOfStatusCalls.set("ARCHIVE_DEFINED", "resetArchiveDefined");
    this.mapOfStatusCalls.set("ARCHIVED", "resetArchived");

    let element = document.getElementById("searchField");
    element.focus();
    this.searchedBatch = new Covid19Batch();
    this.fetchLabDetails();

    this.covid19PoolsToBeDisplayed = [];
    this.pooledSamplesMaxSize = 0;
    this.getActivePrinters();
    this.getActivePrintBarcodeTemplate();
    this.getWorkFlowList();

    //setting isUpdateWorkflowBtnDisabled to false so that user is not able to change Workflow. This is based on the decision on 21st July 2021
    this.isUpdateWorkflowBtnDisabled = true;
    this.isResetWorkflowDropdownReadOnly = true;
    this.ncSampleCreate = new NCSample();
    this.updatedDepoolingRetestDTO = new Falcon();
  }

  fetchLabDetails() {
    this.masterDataService.findLabById(this.selectedLabId).subscribe(
      (result) => {
        if (
          result.data == null ||
          result.data == undefined ||
          result.data.length == 0
        ) {
          this._messagesService.addErrorMessage({
            severity: "error",
            summary: "Lab not found!",
            detail: "Contact Administrator to resolve this issue.",
          });
          return;
        }
        this.selectedLab = result.data;
      },
      (error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  decideIfBBRoleExists() {
    let roles = this.getRolesFromAccessToken();
    if (roles.length > 0) {
      return this.checkIfAnyLabRoleExists(roles);
    }
    return false;
  }

  private checkIfAnyLabRoleExists(roles: any) {
    return (
      (roles.includes(this.blueberrySilverstoneBatchAction) &&
        roles.includes(this.blueberrySilverstoneUser)) ||
      (roles.includes(this.blueberryBirchwoodBatchAction) &&
        roles.includes(this.blueberryBirchwoodUser)) ||
      (roles.includes(this.blueberryAPGUKTeddingtonBatchActionUsers) &&
        roles.includes(this.blueberryAPGUKTeddingtonLabUsers)) ||
      (roles.includes(this.blueberryAPGBatchAction) &&
        roles.includes(this.blueberryAPGEBEUser)) ||
      (roles.includes(this.blueberryDenmarkBatchAction) &&
        roles.includes(this.blueberryDenmarkUser)) ||
      (roles.includes(this.blueberryNetherlandsBatchAction) &&
        roles.includes(this.blueberryNetherlandsUser)) ||
      (roles.includes(this.blueberryCologneBatchAction) &&
        roles.includes(this.blueberryCologneUser)) ||
      (roles.includes(this.blueberryCPHBatchAction) &&
        roles.includes(this.blueberryCPHUser)) ||
      (roles.includes(this.blueberryswedenBatchAction) &&
        roles.includes(this.blueberrySwedenUser)) ||
      (roles.includes(this.blueberryAustraliaBatchAction) &&
        roles.includes(this.blueberryAustraliaUser))
    );
  }

  getRolesFromAccessToken() {
    let authUtil = new AuthUtil();
    let accessToken = authUtil.getAccessToken();
    if (accessToken) {
      let access_token = jwt_decode(accessToken);
      return access_token.roles;
    }
    return [];
  }

  populateChaoticPoolSearchData(result: BBResponseContainer) {
    this.batchID = result.data.targetBatchId;
    this.poolArray = result.data.sourceBarcode;
    this.batchSenderNames = result.data.sampleSender;
    this.sampleSource = result.data.sampleSourceBatch;
    this.barcode = result.data.barcode;
    this.myMap = result.data.sampleBatchMap;

  }

  search(searchID: string) {
    this.searchSuccess = false;
    this.sampleSearch = false;
    this.poolSearch = false;
    this.showNcSample = false;
    this.preperationPoolSearch = false;
    this.chaotincPoolSearch = false;
    this.poolNewSearch = false;
    this.falconSampleSearch = false;
    this.bagIdSampleSearch = false;
    this.boxIdSampleSearch = false;
    this.pooledSamplesMaxSize = 0;
    this.covid19PoolsToBeDisplayed = [];
    this.ncboxId = '';
    this.ncBarcode = '';
    searchID = searchID.trim();
    if (this.searchSelection == 'batch') {
      this.searchForBatch(searchID);
    }
    else if (this.searchSelection == 'sample') {
      this.searchForSample(searchID);
    } else if (this.searchSelection == 'preperationPool') { // pppp we have to remove
      this.searchForPreperationPool(searchID);
    } else if (this.searchSelection == 'chaotincPool') { // pppp newly added block
      this.searchForChaotincPool(searchID);
    }
    else if (this.searchSelection == 'NCSampleSearch') {
      this.loadNcSample(searchID);
    } else if (this.searchSelection == 'lolliPooling') {
      this.loadFalconSample(searchID);
    }
    else if (this.searchSelection == 'bagIdSearch') {
      this.loadBagIdSample(searchID);
    }
    else if (this.searchSelection == 'boxIdSearch') {
      this.loadBoxIdSample(searchID);
    }
    else {
      this.searchForPool(searchID);
    }
  }

  searchForChaotincPool(searchID: string) {
    this.chaoticPoolSearchId = searchID;
    this.apgAdminService.searchChaotincPool(this.selectedLabId, searchID)
      .subscribe(
        (result) => {
          if (result && result.data.responseFlag) {
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Chaotic Pool search Successful',
              detail: 'Pool search is successful with search id ' + searchID,
            });
            this.chaotincPoolSearch = true;
            this.populateChaoticPoolSearchData(result);
          }
          else {
            this.chaotincPoolSearch = false;
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Chaotic Pool search failed !!!',
              detail: result.data.errorMessage,
            });

          }
        }, (err) => {
          this.errorHandlerDisplay(err);
        }
      )
  }


  getChaoticBgColor(id: string) {
    if (id && id == this.chaoticPoolSearchId) {
      return {
        "background-color": "lightgreen",
      };
    } else {
      return {}
    }
  }

  loadNcSample(searchID: string) {
    if (!searchID || searchID.trim() == "") {
      this._messagesService.addWarningMessage({
        severity: "warn",
        summary: "Batch ID Empty",
        detail: "Please enter Batch ID to search",
      });
      return;
    }
  }
  getImages() {

  }
  searchForBatch(batchID: string) {
    if (!batchID || batchID.trim() == "") {
      this._messagesService.addWarningMessage({
        severity: "warn",
        summary: "Batch ID Empty",
        detail: "Please enter Batch ID to search",
      });
      return;
    }
    this.apgAdminService
      .getBatchForLabAndBatchId(this.selectedLabId, batchID)
      .subscribe(
        (result) => {
          this.searchedBatch = result.data;
          this.commentsMap = new Map<string, Comment[]>();
          this.batchCommentVisibility = new Map<string, boolean>();
          this.batchID = this.searchedBatch.batchID;
          if (this.searchedBatch.statusOfTheBatch == 'SCAN_COMPLETE' || this.searchedBatch.statusOfTheBatch == 'CREATE_BATCH') {
            this.isResetWorkflowDropdownReadOnly = false;
            this.isUpdateWorkflowBtnDisabled = false;
          } else {
            this.isResetWorkflowDropdownReadOnly = true;
            this.isUpdateWorkflowBtnDisabled = true;
          }
          this.resetBatchData();
          this.setSubSenders();
          this.populateBatchHistory();
          this.searchSuccess = true;
          if (!this.searchedBatch.workFlow) {
            this._messagesService.addWarningMessage({ severity: 'warn', summary: "No Workflow", detail: "No workflow assign to this batch, select a workflow and update the workflow " });
          } else {
            this.selectedWorkFlow = this.searchedBatch.workFlow;
          }
        },
        (error) => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      );


  }
  redoDisabled() {
    return (
      !this.searchedBatch ||
      this.searchedBatch.statusOfTheBatch == "MERGE_STARTED" ||
      this.isMergedBatch() ||
      ["REDO", "REMOVED"].includes(this.searchedBatch.statusOfTheBatch) ||
      !this.validRole
    );
  }

  redoLysisDisabled() {
    return (
      this.searchedBatch.swabType != "Wet" && this.searchedBatch.swabType != "Dry"
    );
  }

  resetStatus() {
    let dialogMessage =
      "Do you really want to update the Batch " +
      this.searchedBatch.batchID +
      "?";
    this.confirmationService.confirm({
      message: dialogMessage,
      header: "Confirmation",
      icon: "fa fa-question-circle",
      accept: () => {
        if (this.selectedResetStatus) {
          let functionName = this.mapOfStatusCalls.get(
            this.selectedResetStatus
          );
          this[functionName]();
        } else {
          this.saveBatchData();
        }
      },
      reject: () => {
        this.selectedResetStatus = null;
      },
    });
  }

  resetStartClipping() {
    this.searchedBatch.clippingStartDateTime = null;
    this.searchedBatch.puidClipping = null;
    this.updateBatch("SCAN_COMPLETE");
  }

  resetCompleteClipping() {
    this.searchedBatch.puidCompleteClipping = null;
    this.searchedBatch.clippingCompletionDateTime = null;
    this.updateBatch("START_CLIPPING");
  }

  resetSampleReceptionChecked() {
    this.searchedBatch.completenessCheckDateTime = null;
    this.searchedBatch.puidController2 = null;
    this.updateBatch("COMPLETE_CLIPPING");
  }

  resetStartLysis() {
    this.searchedBatch.lysisStartDateTime = null;
    this.searchedBatch.puidstartLysis = null;
    this.updateBatch("SAMPLE_RECEPTION_CHECKED");
  }

  resetCompleteLysis() {
    this.searchedBatch.puidCompleteLysis = null;
    this.searchedBatch.lysisCompletionDateTime = null;
    this.updateBatch("START_LYSIS");
  }

  resetStartExtraction() {
    this.searchedBatch.startExtraction = null;
    this.searchedBatch.puidStartExtraction = null;
    this.updateBatch("COMPLETE_LYSIS");
  }

  resetExtractionComplete() {
    this.searchedBatch.completionDateTimeExtraction = null;
    this.searchedBatch.puidExtraction = null;
    this.updateBatch("START_EXTRACTION");
  }

  resetStartPreCycling() {
    this.searchedBatch.precyclingStartDateTime = null;
    this.searchedBatch.puidstartPrecycling = null;
    this.updateBatch("EXTRACTION_COMPLETE");
  }

  resetCompletePreCycling() {
    this.searchedBatch.precyclingCompletionDateTime = null;
    this.searchedBatch.puidCompletePrecycling = null;
    this.updateBatch("START_PRECYCLING");
  }

  resetStartCycling() {
    this.searchedBatch.startDatePCR = null;
    this.searchedBatch.puidPCR2 = null;
    this.updateBatch("COMPLETE_PRECYCLING");
  }

  resetCyclerComplete() {
    this.searchedBatch.completionDateTimePCR = null;
    this.searchedBatch.puidPCR1 = null;
    this.updateBatch("START_CYCLING");
  }

  resetAnalysisStarted() {
    this.searchedBatch.analysisStartedPUID = null;
    this.searchedBatch.analysisStartedDateTime = null;
    this.updateBatch("CYCLER_COMPLETE");
  }

  resetAnalysisDone() {
    this.searchedBatch.completionDateTimeEvaluation = null;
    this.searchedBatch.puidEvaluation = null;
    this.updateBatch("ANALYSIS_STARTED");
  }

  resetResultFileSent() {
    this.searchedBatch.resultSentDateTime = null;
    this.searchedBatch.resultDispatchedyPUID = null;
    this.updateBatch("ANALYSIS_DONE");
  }

  resetArchiveDefined() {
    this.updateBatch("ARCHIVE_DEFINED");
  }

  resetArchived() {
    this.searchedBatch.archiveProcessedDateTime = new Date();
    this.updateBatch("ARCHIVED");
  }

  updateBatch(statusOfBatch: string) {
    this.searchedBatch.statusOfTheBatch = statusOfBatch;
    this.searchedBatch.previousStatusOfTheBatch = statusOfBatch;
    this.saveBatchData();
  }

  disableUpdateBatch() {
    return (
      !this.validRole ||
      (this.enableUpdateButton() && !this.selectedResetStatus)
    );
  }
  enableUpdateButton() {
    return (
      this.rushSample == this.searchedBatch.rushSample && this.superRush == this.searchedBatch.superRush &&
      this.locked == this.searchedBatch.locked
    );
  }
  saveBatchData() {
    this.searchedBatch.lab = this.selectedLabId;
    this.searchedBatch.userID = this.puid;
    this.blocked = true;
    this.apgAdminService
      .changeBatchStatus(
        this.searchedBatch,
        this.selectedLab.numberOfPositivePCRControls,
        this.selectedLab.numberOfNegativePCRControls
      )
      .subscribe(
        (result) => {
          if (result.data) {
            this.searchedBatch = result.data;
            this.resetBatchData();
            this._messagesService.addSuccessMessage({
              severity: "success",
              summary: "Batch Updated!",
              detail:
                "Batch " +
                this.searchedBatch.batchID +
                " has been updated successfully",
            });
            this.blocked = false;
          }
        },
        (error) => {
          this.blocked = false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      );
  }

  resetBatchData() {
    this.rushSample = this.searchedBatch.rushSample;
    this.superRush = this.searchedBatch.superRush;
    this.locked = this.searchedBatch.locked;
    this.statusListWithArchive = [...this.statusSelectionList];
    if (
      this.searchedBatch.archiveBatchSources &&
      this.searchedBatch.archiveBatchSources.length > 0
    ) {
      this.statusListWithArchive.push({
        label: "Archive Defined",
        value: "ARCHIVE_DEFINED",
      });
      this.statusListWithArchive.push({ label: "Archived", value: "ARCHIVED" });
    }
  }
  redoAction() {
    let repeatLysisMessage = "";
    if (
      this.searchedBatch.redoCount > 0 &&
      this.selectedRedoReasonStep == "Redo_Lysis" &&
      this.searchedBatch.batchID
        .substring(this.searchedBatch.batchID.lastIndexOf("_"))
        .includes("L") &&
      this.searchedBatch.swabType == "Dry"
    ) {
      repeatLysisMessage = "This Batch has already undergone Redo Lysis, Are you sure you want to attempt Redo Lysis again?";
    }
    this.confirmationService.confirm({
      message: "Do you really want to Redo " + this.searchedBatch.batchID + "? " + repeatLysisMessage,
      header: "Confirmation",
      icon: "fa fa-question-circle",
      accept: () => {
        if (this.selectedRedoReasonStep == 'Redo_PCR') {
          this.selectedRedoStep = 'EXTRACTION_COMPLETE';
        } else if (this.selectedRedoReasonStep == 'Redo_Lysis') {
          this.selectedRedoStep = 'SAMPLE_RECEPTION_CHECKED';
        }
        this.searchedBatch.redoStep = this.selectedRedoReasonStep;
        // this.searchedBatch.redoChannel = this.selectedRedoReasonChannel;

        let redosearchedBatch = this.searchedBatch;
        redosearchedBatch.redoStatus = this.selectedRedoStep;
        redosearchedBatch.redoReason =
          this.selectedRedoReason != "Other"
            ? this.selectedRedoReason
            : this.enteredRedoReason;

        redosearchedBatch.redoDateTime = new Date();
        redosearchedBatch.redoPUID = this.puid;
        this.blocked = true;
        this.apgAdminService.redoBatchService(redosearchedBatch).subscribe(
          (result) => {
            if (result.data) {
              this.searchedBatch = result.data;
              this._messagesService.addSuccessMessage({
                severity: "success",
                summary: "Redo Batch Created!",
                detail:
                  "Redo Batch " +
                  result.data.batchID +
                  " has been created for user " +
                  this.puid,
              });
              this.selectedRedoReason = null;
              this.selectedRedoStep = null;
              this.enteredRedoReason = null;
              this.redoReasonsPopup = false;
            }
            this.blocked = false;
          },
          (error) => {
            this.blocked = false;
            let message = this.errorHandler.handleError(error);
            message.summary = "REDO Error";
            this._messagesService.addErrorMessage(message);
          }
        );
      },
      reject: () => {

      },
    });
  }

  confirmRemoveBatch() {
    let dialogMessage =
      "Do you really want to remove the Batch " +
      this.searchedBatch.batchID +
      "?";
    this.confirmationService.confirm({
      message: dialogMessage,
      header: "Confirmation",
      icon: "fa fa-question-circle",
      accept: () => {
        this.removeBatch();
      },
      reject: () => {

      },
    });
  }

  removeBatch() {
    this.blocked = true;
    this.apgAdminService
      .removeBatch(
        this.selectedLabId,
        JSON.parse(localStorage.getItem("lab")).lab.name,
        this.searchedBatch.batchID
      )
      .subscribe(
        (result) => {
          if (result.data) {
            this._messagesService.addSuccessMessage({
              severity: "success",
              summary: "Batch Removed!",
              detail: result.data,
            });
            this.searchedBatch.statusOfTheBatch = "REMOVED";
            this.searchedBatch.version = this.searchedBatch.version + 1;
          }
          this.blocked = false;
        },
        (error) => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
          this.blocked = false;
        }
      );
  }

  searchForSample(searchID: string) {
    if (["POS_EX", "NTC_EX", "PCR-PC", "PCR-NTC"].includes(searchID)) {
      this._messagesService.addErrorMessage({
        severity: "error",
        summary: "Invalid Barcode!",
        detail:
          "Can not Search with Controls...Please enter a valid Sample Barcode",
      });
      return;
    } else if (searchID === "NC-DUMMY") {
      this._messagesService.addErrorMessage({
        severity: "error",
        summary: "Invalid Barcode!",
        detail:
          "Can not Search with NC-DUMMY...Please enter a valid Sample Barcode",
      });
      return;
    }
    this.blocked = true;
    this.gettingSamplesHistory(searchID);
    this.apgAdminService
      .fetchSampleInfo(this.selectedLabId, searchID)
      .subscribe(
        (result: any) => {
          const { batchOrShippedBarcode = null, samplesAndPoolsInSuperPool = {} } = result;
          const { samples = [], superPoolId = '', poolIds = [] } = samplesAndPoolsInSuperPool;
          if (batchOrShippedBarcode || samples.length) {
            if (batchOrShippedBarcode) {
              this.sampleInfo = batchOrShippedBarcode;
              this.destination = batchOrShippedBarcode.destination;
              this.commentsMap = new Map<string, Comment[]>();
              this.batchCommentVisibility = new Map<string, boolean>();
              this.batchID = this.sampleInfo.analysisBatch;
            }
            this.sampleInfo = Object.assign({}, this.sampleInfo, { samples, superPoolId, poolIds });
            this.sampleSearch = true;
            if (this.sampleInfo.status == 'START_EXTRACTION') {
              this.ncboxId = this.sampleInfo.boxId;
              this.ncBarcode = this.sampleInfo.barcode;
            }
          } else {
            this._messagesService.addErrorMessage({
              severity: "error",
              summary: "No Data Found",
              detail: "Sample Data not found for barcode " + searchID,
            });
          }
          this.blocked = false;
        },
        (error) => {
          let errMsg = this.errorHandler.handleError(error);
          this.blocked = false;
          this._messagesService.addErrorMessage(errMsg);
        }
      );
  }

  gettingSamplesHistory(searchID: string) {

    this.sourceBatchListDetails = [];
    this.analysisBatchListDetails = [];
    this.sampleAllHistory = [];
    this.sampleResults = []
    this.viewAnalysisBatchResults = [];
    this.firstAnalysisBatchResults = [];
    this.singleSampleRedoCount = 0;
    this.samplePosition = '';

    this.apgAdminService.fetchSampleAllBatchInfo(this.selectedLabId, searchID)
      .subscribe(results => {
        if (results && results.length > 0) {
          if (results[0].singleSampleRedoCount > 0) {
            this.singleSampleRedoCount = results[0].singleSampleRedoCount;
          }
          for (let k = 0; k < results.length; k += 2) {
            if (results[k].machineName == null || results[k].machineName == '') {
              this.sourceBatchListDetails.push({ "sourceBatch": results[k].batchId, "sourcePosition": results[k].wellQuadrant });
              k = this.getSourceAndAnalysisMethod(results, k);
            } else if (results[k].machineName != null && results[k].machineName != '') {
              this.viewAnalysisBatchResults.push(results[k]);
              this.analysisBatchListDetails.push({ "analysisBatch": results[k].batchId, "analysisPosition": results[k].wellQuadrant, "rtpcrKit": results[k].rtPCRKitVendor });
              this.sourceBatchListDetails.push({ "sourceBatch": "", "sourcePosition": "" });
              this.gettingSourceAndAnalysisMethodContinution(results, k);
            }
          }
          this.sourceAnalysisBatchesAndPositions();
        }

        this.viewAllResultsConditionInfo();
        this.primaryAndSecondaryResultDetailsInfo();
      });
  }


  getSourceAndAnalysisMethod(results: any, k: number) {
    if (results[k + 1] && (results[k + 1].machineName != null && results[k + 1].machineName != '')) {
      this.analysisBatchListDetails.push({ "analysisBatch": results[k + 1].batchId, "analysisPosition": results[k + 1].wellQuadrant, "rtpcrKit": results[k + 1].rtPCRKitVendor });
      this.viewAnalysisBatchResults.push(results[k + 1]);
    } else if (results[k + 1] && (results[k + 1].machineName == null || results[k + 1].machineName == '')) {
      this.analysisBatchListDetails.push({ "analysisBatch": "", "analysisPosition": "", "rtpcrKit": "" });
      this.sourceBatchListDetails.push({ "sourceBatch": results[k + 1].batchId, "sourcePosition": results[k + 1].wellQuadrant });
      if (results[k + 2] && results[k + 2].machineName != null && results[k + 2].machineName != '') {
        this.analysisBatchListDetails.push({ "analysisBatch": results[k + 2].batchId, "analysisPosition": results[k + 2].wellQuadrant, "rtpcrKit": results[k + 2].rtPCRKitVendor });
        this.viewAnalysisBatchResults.push(results[k + 2]);
        k = k + 1;
      } else {
        this.analysisBatchListDetails.push({ "analysisBatch": "", "analysisPosition": "", "rtpcrKit": "" });
      }
    }
    return k;
  }

  gettingSourceAndAnalysisMethodContinution(results: any, k: number) {
    if (results[k + 1] && (results[k + 1].machineName != null && results[k + 1].machineName != '')) {
      this.viewAnalysisBatchResults.push(results[k + 1]);
      this.analysisBatchListDetails.push({ "analysisBatch": results[k + 1].batchId, "analysisPosition": results[k + 1].wellQuadrant, "rtpcrKit": results[k + 1].rtPCRKitVendor });
      this.sourceBatchListDetails.push({ "sourceBatch": "", "sourcePosition": "" });
    } else if (results[k + 1] && (results[k + 1].machineName == null || results[k + 1].machineName == '')) {
      this.sourceBatchListDetails.push({ "sourceBatch": results[k + 1].batchId, "sourcePosition": results[k + 1].wellQuadrant });
    }
  }

  viewAllResultsConditionInfo() {
    if (this.viewAnalysisBatchResults.length > 0) {
      for (const record of this.viewAnalysisBatchResults) {
        if (record && record.batchStatus === 'COMPLETED' && record.rtpcrKit !== null && record.rtpcrKit !== '' && record.channels.length > 0) {
          this.firstAnalysisBatchResults.push(record);
        }
        if (record && record.batchStatus === 'COMPLETED' && record.rtpcrKit !== null && record.rtpcrKit !== '' && record.sampleResults.length > 0) {
          this.sampleResults.push(record.sampleResults);
        }
      }
    }

    if (this.firstAnalysisBatchResults.length > 0) {
      this.assignSamples(this.firstAnalysisBatchResults[0]);
    } else {
      this.assignSamples(this.resultView);
    }
  }

  primaryAndSecondaryResultDetailsInfo() {
    this.primarySampleResult1 = '';
    this.primarySampleResult2 = '';
    this.secondarySampleResult1 = '';
    this.secondarySampleResult2 = '';
    let samplersultsLength = this.sampleResults[0] ? this.sampleResults[0].length : 0;
    let samplersultsLength1 = this.sampleResults[1] ? this.sampleResults[1].length : 0;

    for (let i = 0; i < samplersultsLength; i++) {
      if (i % 2 === 0) {
        this.primarySampleResult1 = this.sampleResults[0][i].sampleResult;
      } else {
        this.secondarySampleResult1 = this.sampleResults[0][i].sampleResult;
      }
    }


    for (let i = 0; i < samplersultsLength1; i++) {
      if (i % 2 === 0) {
        this.primarySampleResult2 = this.sampleResults[1][i].sampleResult;
      } else {
        this.secondarySampleResult2 = this.sampleResults[1][i].sampleResult;
      }
    }
  }
  sourceAnalysisBatchesAndPositions() {
    const analysis = [];
    const source = [];
    if (this.sourceBatchListDetails.length > 0) {
      for (const record of this.sourceBatchListDetails) {
        if (record.sourceBatch != null && record.sourcePosition != null) {
          source.push({ "sourceBatch": record.sourceBatch, "sourcePosition": record.sourcePosition });
        }
      }
    }

    if (this.analysisBatchListDetails.length > 0) {
      for (const record of this.analysisBatchListDetails) {
        if (record.analysisBatch != null && record.analysisPosition != null) {
          analysis.push({ "analysisBatch": record.analysisBatch, "analysisPosition": record.analysisPosition, "rtpcrKit": record.rtpcrKit });
        }
      }
    }
    this.sampleAllHistory = source.map((item, i) => Object.assign({}, item, analysis[i]));
  }

  assignSamples(result: any) {
    this.channelAssosiatedToDisease = [];
    this.channelAssociate = [];
    let sampleChannels: any = [];
    this.resultView = new ResultViewDTO();
    this.sampleResultView = new SampleResultViewDTO();
    if (result && result.wellQuadrant) {
      this.sampleResultView.wellQuadrant = result.wellQuadrant;
      this.samplePosition = result.wellQuadrant;
    }
    if (result && result.channels && result.channels.length > 0) {
      result.channels.forEach((channel) => {
        let localChannel: Channel = new Channel(channel.gene);
        localChannel.cpValue = channel.cpValue;
        localChannel.geneResult = channel.geneResult;
        sampleChannels[channel.gene] = localChannel;
        this.channelAssociate.push(channel.gene);

      });

      this.channelAssosiatedToDisease.push({ "channelAssosiatedToDisease": this.channelAssociate, "diseaseName": 'Covid' });

      this.sampleResultView.channels = sampleChannels;
      this.sampleResultView.results = result.sampleResults;
      this.sampleResultView.result = result.sampleResult;
      this.resultView.samples = this.sampleResultView;
      this.resultView.channelTestingTypeMapping = this.channelAssosiatedToDisease;
    }
  }
  getPositionString(row: number, col: number) {
    if (row != undefined && col != undefined) {
      return String.fromCharCode(64 + row) + col;
    }
  }

  getStyleForResult(result: string) {
    if (result && result.trim() != "") {
      if (result === "positive")
        return {
          color: "red",
        };
      else if (result === "negative")
        return {
          color: "green",
        };
      else
        return {
          color: "#ffbf00",
        };
    }
  }

  getContaminationString(sampleInfo: any): string {
    let contaminationString = "";
    if (
      sampleInfo.contamination &&
      sampleInfo.contamination != "No Contamination"
    ) {
      contaminationString = sampleInfo.contamination;
      if (
        sampleInfo.contaminationComment &&
        sampleInfo.contaminationComment.trim() != ""
      )
        contaminationString =
          contaminationString + "( " + sampleInfo.contaminationComment + " )";
    }
    return contaminationString;
  }

  disableSearchIf(searchID: string): boolean {
    return !searchID || searchID.trim() == "";
  }

  getCommentKeys(commentMap: Map<string, Comment>) {
    return Array.from(commentMap.keys());
  }

  toggleBatchContent(batchID: string, showState: boolean) {
    this.batchCommentVisibility.set(batchID, showState);
  }

  showComments(batchResult: boolean) {
    if (batchResult) {
      this.formCommentsMap(this.searchedBatch.comments, batchResult);
    } else {
      this.formCommentsMap(this.sampleInfo.comment, batchResult);
    }
    this.showCommentDialog = true;
  }

  formCommentsMap(comments: Comment[], batchResult: boolean) {
    if (!comments || this.commentsMap.size != 0) {
      return;
    }
    this.batchCommentVisibility = new Map<string, boolean>();
    comments.forEach((comment) => {
      let cmnt = this.getArrayOfCommentsToAnother(
        comment.batchId,
        comment,
        batchResult
      );
      this.commentsMap.set(comment.batchId, cmnt);
      this.batchCommentVisibility.set(comment.batchId, true);
    });
  }

  getArrayOfCommentsToAnother(
    batchID: string,
    comment: Comment,
    batchResult: boolean
  ) {
    let commentItem = this.commentsMap.get(batchID);
    if (!commentItem) {
      commentItem = [];
    }
    if (!batchResult) {
      comment.commentDate = comment.commentDate["$date"];
    }
    commentItem.push(Object.assign({}, comment));
    return commentItem;
  }

  deleteDisabledIf() {
    return !(
      this.batchIdToDeleteSample && this.batchIdToDeleteSample.trim() != ""
    );
  }

  deleteSample(searchField: HTMLInputElement) {
    let dialogMessage =
      "Do you really want to Delete the Sample " + searchField.value + "?";
    this.confirmationService.confirm({
      message: dialogMessage,
      header: "Confirmation",
      icon: "fa fa-question-circle",
      accept: () => {
        this.blocked = true;
        this.apgAdminService
          .deleteSampleFromBatch(
            this.selectedLabId,
            searchField.value,
            this.batchIdToDeleteSample
          )
          .subscribe(
            (result) => {
              searchField.value = null;
              this.sampleSearch = false;
              this.sampleInfo = null;
              this.batchIdPopup = false;
              this._messagesService.addSuccessMessage({
                severity: "success",
                summary: "Deleted Sample!",
                detail: result.data,
              });
              this.blocked = false;
            },
            (error) => {
              let message = this.errorHandler.handleError(error);
              this.blocked = false;
              this._messagesService.addErrorMessage(message);
            }
          );
      },
      reject: () => {

      },
    });
  }

  confirmFalseRedo() {
    this.confirmationService.confirm({
      message:
        "Do you really want to Correct False Redo For Batch: " +
        this.searchedBatch.batchID +
        "?",
      header: "Confirmation",
      icon: "fa fa-question-circle",
      accept: () => {
        this.blocked = true;
        this.apgAdminService
          .changeFalseRedo(
            this.selectedLabId,
            this.searchedBatch,
            this.searchedBatch.redoCount
          )
          .subscribe(
            (result) => {
              this.searchedBatch = result.data;
              this._messagesService.addSuccessMessage({
                severity: "success",
                summary: "Corrected Redo!",
                detail:
                  "Redo has been changed to " + this.searchedBatch.batchID,
              });
              this.blocked = false;
            },
            (error) => {
              let msg = this.errorHandler.handleError(error);
              this._messagesService.addErrorMessage(msg);
              this.blocked = false;

            }
          );
      },
      reject: () => {

      },
    });
  }

  setRedoStep(status: string, redoStep: string) {
    this.findKit();
    this.selectedRedoReason = null;
    this.noRedoReasonConfiguredForLab = false;
  }

  redoButtonDisabledIf() {
    if (!this.selectedRedoReason || !this.selectedRedoReasonStep || (!this.askForChannelDisabled && !this.selectedRedoReasonChannel) ||
      (this.selectedRedoReasonStep == "Redo_Lysis" && this.redoLysisDisabled()))
      return true;
    else if (this.selectedRedoReason != "Other") return false;
    else
      return !(this.enteredRedoReason && this.enteredRedoReason.trim() != "");
  }

  removeDisabledIf(): boolean {
    return !(
      this.searchedBatch &&
      this.searchedBatch.redoCount == 0 &&
      !["REDO", "COMPLETED", "REMOVED"].includes(
        this.searchedBatch.statusOfTheBatch
      ) &&
      !this.isMergedBatch() &&
      this.validRole
    );
  }

  removeUnnecessaryRedoDisabledIf(): boolean {
    return !(
      this.searchedBatch &&
      this.searchedBatch.redoCount > 0 &&
      !this.isMergedBatch() &&
      this.validRole
    );
  }

  changeFalseRedoDisabledIf(): boolean {
    return !(
      this.searchedBatch &&
      this.searchedBatch.redoCount > 0 &&
      !["REDO", "COMPLETED", "REMOVED"].includes(
        this.searchedBatch.statusOfTheBatch
      ) &&
      !this.isMergedBatch() &&
      !this.isRedoExtractionBatch() &&
      this.validRole &&
      !this.isReAnalyzedWetBatch()
    );
  }

  isMergedBatch(): boolean {
    return this.searchedBatch.wellType == WellType.WELL384;
  }

  isReAnalyzedWetBatch() {
    let batchExtension = this.searchedBatch.batchID.substring(
      this.searchedBatch.batchID.lastIndexOf("_") + 1
    );
    return (
      this.searchedBatch.createdFromAnalysis &&
      this.searchedBatch.swabType == "Wet" &&
      batchExtension.charAt(batchExtension.length - 1) == "Q"
    );
  }

  selectBatchToComplete() {
    this.searchSelection = "batch";
    this.parentBatches = [];
    let batchIdForSelection = this.searchedBatch.batchID;
    while (true) {
      this.parentBatches.unshift(batchIdForSelection);
      batchIdForSelection = batchIdForSelection.slice(0, -1);
      if (batchIdForSelection.endsWith("_")) {
        batchIdForSelection = batchIdForSelection.slice(0, -1);
        this.parentBatches.unshift(batchIdForSelection);
        break;
      }
    }
    this.removeUnnecessaryPopup = true;
  }

  removeUnnecessaryRedo() {
    let batchIdsTobeRemoved: string[] = [];
    let index = this.parentBatches.indexOf(this.selectedBatchIdToComplete) + 1;
    batchIdsTobeRemoved = this.parentBatches.slice(
      index,
      this.parentBatches.length
    );
    this.blocked = true;
    this.apgAdminService
      .removeUnnecessaryRedo(
        this.selectedLabId,
        this.selectedBatchIdToComplete,
        batchIdsTobeRemoved
      )
      .subscribe(
        (result) => {
          this._messagesService.addSuccessMessage({
            severity: "success",
            summary: "Batch Removed!",
            detail: result.data,
          });
          this.removeUnnecessaryPopup = false;
          this.selectedBatchIdToComplete = null;
          this.searchedBatch.statusOfTheBatch = "REMOVED";
          this.searchedBatch.version = this.searchedBatch.version + 1;
          this.blocked = false;
        },
        (error) => {
          this.blocked = false;
          let errorMessage = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(errorMessage);
        }
      );
  }

  isRedoExtractionBatch() {
    if (this.searchedBatch.redoCount > 0) {
      let batchExtension = this.searchedBatch.batchID.substring(
        this.searchedBatch.batchID.lastIndexOf("_") + 1
      );
      return batchExtension.charAt(batchExtension.length - 1) == "E";
    }
    return false;
  }
  shipToSender() {
    this.blocked = true;
    this.shipToSenderDTO = new ShipToSenderDTO();
    this.shipToSenderDTO.shippedTimestamp = new Date();
    this.shipToSenderDTO.shippedUserPUID = this.puid;
    this.shipToSenderDTO.labId = this.selectedLabId;
    this.shipToSenderDTO.sample = this.sampleInfo.barcode;
    this.shipToSenderDTO.batchID = this.sampleInfo.analysisBatch;
    this.shipToSenderDTO.destination = this.destination;
    this.sampleInfo.shippedUserPUID = this.puid;
    this.sampleInfo.shippedTimestamp = new Date();
    this.apgAdminService.shipToSender(this.shipToSenderDTO).subscribe(
      (result) => {
        if (result == 1) {
          this._messagesService.addSuccessMessage({
            severity: "success",
            summary: "Shipped To Sender",
            detail: "Updated  " + result + "  Batch",
          });
          this.blocked = false;
          this.searchForSample(this.sampleInfo.barcode)
        } else {
          this._messagesService.addErrorMessage({
            severity: "error",
            summary: "Ship To Sender Failed",
            detail: "Couldn't Update  Batch",
          });
          this.blocked = false;
        }
      },
      (error) => {
        let errorMSG = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errorMSG);
        this.blocked = false;
      }
    );
  }
  disableShiptoSender() {
    return !((
      this.sampleInfo.status == "COMPLETED" ||
      this.sampleInfo.status == "ANALYSIS_DONE" ||
      this.sampleInfo.status == "DATA_READY") && (
        this.destination &&
        this.destination.trim() != "")
    );
  }
  getresultView() {
    return this.resultView;
  }

  getRedoResonsDetails() {
    this.selectedRedoReasonInfo = null;
    this.askForChannelDisabled = false;
    this.selectedRedoReasonStep = null;
    this.selectedRedoReasonChannel = null;
    this.redoReasons.forEach(readoReson => {
      if (this.selectedRedoReason == readoReson.reasonName) {
        this.selectedRedoReasonInfo = readoReson.reasonInfo;
        this.askForChannelDisabled = !readoReson.askForChannel;
        if (readoReson.defaultRedoStep) {
          if (readoReson.defaultRedoStep == "REDO_PCR") {
            this.selectedRedoReasonStep = "Redo_PCR";
          } else if (readoReson.defaultRedoStep == "REDO_LYSIS") {
            this.selectedRedoReasonStep = "Redo_Lysis";
          }
        }
      }
    });
    if (this.redoChannelList.length < 1) {
      this.askForChannelDisabled = true;
    }
  }

  findKit() {
    this.redoReasons = [];
    this.redoChannelList = [];
    this.masterDataService.getKitByName(this.searchedBatch.lab, this.searchedBatch.rtPCRKitVendor, "PCR Kit").subscribe(
      result => {
        if (result.data) {
          this.pcrKitRedoInfoForBatch = result.data;
          this.redoReasons = result.data.kitRedoReason;
          if (result.data.channel1Gene) {
            this.redoChannelList.push({ label: result.data.channel1Gene, value: result.data.channel1Gene });
          }
          if (result.data.channel2Gene) {
            this.redoChannelList.push({ label: result.data.channel2Gene, value: result.data.channel2Gene });
          }
          if (result.data.channel3Gene) {
            this.redoChannelList.push({ label: result.data.channel3Gene, value: result.data.channel3Gene });
          }
          if (result.data.channel4Gene) {
            this.redoChannelList.push({ label: result.data.channel4Gene, value: result.data.channel4Gene });
          }
          if (result.data.channel5Gene) {
            this.redoChannelList.push({ label: result.data.channel5Gene, value: result.data.channel5Gene });
          }
        }
        if (this.redoReasons && this.redoReasons.length < 1) {
          this.findAllActiveRedoReasonsForLab();
        } else {
          this.redoReasons.sort((item1, item2) => item1.reasonCode.localeCompare(item2.reasonCode));
          this.redoReasonsPopup = true;
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  findAllActiveRedoReasonsForLab() {
    this.masterDataService.getRedoReasons(this.selectedLab).subscribe(
      results => {
        if (!results) {
          this.redoReasonsPopup = true;
          this.noRedoReasonConfiguredForLab = true;
          return;
        }
        this.redoReasonsForLab = results.data;
        this.redoReasonsForLab.forEach(ele => {
          if (ele.active) {
            this.redoReasons.push(ele);
          }
        });
        if (this.redoReasons && this.redoReasons.length < 1) {
          this.redoReasonsPopup = true;
          this.noRedoReasonConfiguredForLab = true;
          return;
        }
        this.redoReasons.sort((item1, item2) => item1.reasonCode.localeCompare(item2.reasonCode));
        this.redoReasonsPopup = true;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  searchForPreperationPool(searchID: string) {
    this.poolSearchId = searchID;
    this.blocked = true;
    let searchBy = "";
    if (this.regexMatcher(this.selectedLab.superPoolIDRegex, this.poolSearchId)) {
      searchBy = "sp";
    }
    else if (this.regexMatcher(this.selectedLab.poolIDRegex, this.poolSearchId)) {
      searchBy = "pool";
    }
    else {
      searchBy = "sample";
    }
    this.serviceCallPoolId(searchID, searchBy);
  }

  serviceCallPoolId(searchID: string, searchBy: string) {
    this.apgAdminService.searchPreperationPool(this.selectedLabId, searchID, searchBy)
      .subscribe(
        (result) => {
          this.covid19PoolsToBeDisplayed = result.data;
          if (this.covid19PoolsToBeDisplayed && this.covid19PoolsToBeDisplayed.length > 0) {

            this._messagesService.addSuccessMessage(
              {
                severity: 'success', summary: 'Pool search successful',
                detail: 'Pool search by ' + searchBy + ' is successful with search id ' + searchID
              }
            );
            for (let item of this.covid19PoolsToBeDisplayed) {
              if (item.samples.length > this.pooledSamplesMaxSize) {
                this.pooledSamplesMaxSize = item.samples.length;
              }

            }
            this.setSampleInformationInPoolItem();
          } else {
            this.errorDisplayFunction(searchBy, searchID);
          }
          this.blocked = false;
          this.preperationPoolSearch = true;
        }, (err) => {
          this.errorHandlerDisplay(err);
        }
      )
  }
  searchForPool(searchID: string) {
    this.poolSearchId = searchID;
    this.blocked = true;
    let searchBy = "";
    if (this.regexMatcher(this.selectedLab.superPoolIDRegex, this.poolSearchId)) {
      searchBy = "sp";
    }
    else if (this.regexMatcher(this.selectedLab.poolIDRegex, this.poolSearchId)) {
      searchBy = "pool";
    }
    else {
      searchBy = "sample";
    }
    this.searchForPoolService(searchID, searchBy);
  }

  searchForPoolService(searchID: string, searchBy: string) {
  }

  errorHandlerDisplay(err: string) {
    let errMessage = this.errorHandler.handleError(err);
    this._messagesService.addErrorMessage(errMessage);
    this.blocked = false;
  }

  errorDisplayFunction(searchBy: string, searchID: string) {
    this._messagesService.addErrorMessage({
      severity: "error",
      summary: "No Data Found",
      detail: 'Pool search by ' + searchBy + ', No data found with id ' + searchID
    });
  }

  private setSampleInformationInPoolItem() {
    this.covid19PoolsToBeDisplayed.forEach(item => {
      if (item.sampleInformation != null) {
        item.covid19PoolSampleInfo = JSON.parse(item.sampleInformation);
      } else {
        item.covid19PoolSampleInfo = new Covid19PoolSampleInfo();
      }
    });
  }

  regexMatcher(regex: string, barcode: string): boolean {
    let regexp = new RegExp(regex);
    return regexp.test(barcode);
  }

  getBgColor(id: string) {
    if (id && id == this.poolSearchId) {
      return {
        "background-color": "lightgreen",
      };
    } else {
      return {}
    }
  }

  counter(i: number) {
    return new Array(i);
  }

  confirmCompleteBatch() {
    this.searchedBatch.resultSentDateTime = new Date();
    this.searchedBatch.resultDispatchedyPUID = null;
    this.updateBatch("COMPLETED");
  }

  setSubSenders() {
    const { samples = [], sender = '' } = this.searchedBatch;
    const unboxedSamples: Array<string> = (samples || []).filter(({ unboxedSender = '' }) => unboxedSender)
      .map(({ unboxedSender }) => unboxedSender.toLowerCase());
    this.uniqueSampleSenders = new Set<string>(unboxedSamples);
    this.batchSenderNames = this.uniqueSampleSenders.size ? Array.from(this.uniqueSampleSenders.values()).join(' , ') : sender.toLowerCase();
  }

  isDisabledCompleteBatch() {
    return (!this.validRole || (this.searchedBatch && !this.completeBtn.includes(this.searchedBatch.statusOfTheBatch)));
  }

  populateBatchHistory() {
    let sourceBatchIds = this.searchedBatch.wellType == 'WELL384' ? this.searchedBatch.sourceBatchIds.join(",") : '';

  }

  getActivePrinters() {
    this.masterDataService.getPrinters(true).subscribe((response: BBResponseContainer) => {
      const { data } = response;
      this.printerList = data;
      this.setDefaultOrFirst();
    }, (error: any) => {
      this.showError(error);
    });
  }

  getActivePrintBarcodeTemplate() {
    this.masterDataService.getBarcodePagePrintTemplate(this.selectedLabId, true, true).subscribe((response: BBResponseContainer) => {
      const { data } = response;
      this.templateList = data;
    }, (error: any) => {
      this.showError(error);
      this.blocked = false;
    });
  }

  setDefaultOrFirst() {
    if ((this.printerList || []).length) {
      const defaultPrinter: Printer = this.printerList.find((printer: Printer) => printer.defaultPrinter);
      this.printer = defaultPrinter || this.printerList[0];
    }
  }
  showError(error) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }
  print() {
    this.blocked = true;
    let barcodesList = this.getBarcodesList();
    this.expectedLastPrintValue = barcodesList[barcodesList.length - 1];
    this.selectedTemplate.lastPrintedValue = this.expectedLastPrintValue;
    this.updateTemplate();
    this.printBarcodes(barcodesList);
  }
  printBarcodes(barcodeList: string[]) {

  }
  getBarcodesList() {
    let lastPrintedValue = this.selectedTemplate.lastPrintedValue;
    if (!lastPrintedValue) {
      this._messagesService.addErrorMessage({
        severity: "error",
        summary: "Last Print Info not Found",
        detail: "Check MDM and Printer Config"
      });
      this.blocked = false;
    }
    let barcodesList: string[] = [];
    if (this.selectedTemplate.batchRegex) {
      this.getBarcodeListForBatches(lastPrintedValue, barcodesList);
    } else {
      this.getBarcodeListFornonBatchRegex(lastPrintedValue, barcodesList);
    }
    return barcodesList;
  }
  private getBarcodeListFornonBatchRegex(lastPrintedValue: string, barcodesList: string[]) {
    let prefixCharSeq: string = lastPrintedValue.replace(/[^a-z]/gi, '');
    var regex2 = /\d+/g;
    let number = lastPrintedValue.match(regex2);
    let len = number[0].length;
    let value = +number;
    for (let index = 0; index < this.barcodeCount; index++) {
      value++;
      if (value.toString().length <= len) {
        let numberSuffix = value.toString().padStart(len, '0');
        barcodesList.push(prefixCharSeq + numberSuffix);
      }
    }
  }

  private getBarcodeListForBatches(lastPrintedValue: string, barcodesList: string[]) {
    let charArray = lastPrintedValue.split('_');
    let firstChar = charArray[0];
    let secChar = charArray[1].replace(/[^a-z]/gi, '');
    var regex1 = /\d+/g;
    let number = charArray[1].match(regex1);
    let len = number[0].length;
    let value = +number;
    for (let index = 0; index < this.barcodeCount; index++) {
      value++;
      if (value.toString().length <= len) {
        let numberSuffix = value.toString().padStart(len, '0');
        barcodesList.push(firstChar + '_' + secChar + numberSuffix);
      } else {
        let secCharAscii = secChar.charCodeAt(0);
        if (secCharAscii >= 65 && secCharAscii < 90) {
          value = 0;
          secCharAscii++;
          secChar = String.fromCharCode(secCharAscii);
          let numberSuffix = value.toString().padStart(len, '0');
          barcodesList.push(firstChar + '_' + secChar + numberSuffix);
        }
      }
    }
  }

  updateTemplate() {
    this.masterDataService.updateTemplate(this.selectedTemplate).subscribe(
      results => {
        if (results) {
          this.getActivePrintBarcodeTemplate();
        }
      },
      error => {
        this.showError(error);
        this.blocked = false;
      }
    );
  }
  openPrintingDialog() {
    this.showBarcodePrinting = true;
    this.barcodeCount = 0;
    this.selectedTemplate = null;
    this.getActivePrintBarcodeTemplate();
  }

  getWorkFlowList() {
    this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.workFlow = results.data;
        this.workFlowDropDwon = [];
        this.workFlow.forEach(workFlowItem => {
          this.workFlowDropDwon.push({ label: workFlowItem.workFlowName, value: workFlowItem.workFlowName });
        })

      },
      error => {
        this.workFlow = [];
        this.showError(error);
      }
    );
  }

  updateWorkflow() {
    if (this.selectedWorkFlow == null) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: "Empty Workflow", detail: "Please select workflow for " + this.searchedBatch.batchID });
      return;
    }
    let workFlowItem: WorkFlow = null;
    this.workFlow.forEach(workFlow => {
      if (workFlow.workFlowName == this.selectedWorkFlow) {
        workFlowItem = workFlow;
      }
    })

    if (this.searchedBatch.wellType == WellType.WELL384) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: "Merged batch", detail: "Merge batch can't have workflow" });
    }
    this.apgAdminService.updateWorkFlow(workFlowItem, this.selectedLab._id, this.searchedBatch.batchID).subscribe(
      () => {
        this._messagesService.addSuccessMessage({ severity: 'success', summary: "Batch updated", detail: "Workflow " + this.selectedWorkFlow + " updated to batch " + this.searchedBatch.batchID });
      },
      error => {
        this.showError(error);
      }
    );
  }

  isRedoSamleButtonEnable() {
    return this.sampleInfo.status === 'CREATE_BATCH'
      || this.sampleInfo.status === 'SCAN_COMPLETE'
      || this.sampleInfo.status === 'START_CLIPPING'
      || this.sampleInfo.status === 'COMPLETE_CLIPPING'
      || this.sampleInfo.status === 'SAMPLE_RECEPTION_CHECKED'
      || this.sampleInfo.status === 'START_LYSIS'
      || this.sampleInfo.status === 'COMPLETE_LYSIS'
      || this.sampleInfo.status === 'START_EXTRACTION'
      || this.sampleInfo.status === 'START_EXTRACTOR'
      || this.sampleInfo.status === 'EXTRACTION_COMPLETE'
      || this.sampleInfo.status === 'MERGE_STARTED'
      || this.sampleInfo.status === 'MERGE_COMPLETE'
      || this.sampleInfo.status === 'START_PRECYCLING'
      || this.sampleInfo.status === 'COMPLETE_PRECYCLING'
      || this.sampleInfo.status === 'COMPLETED';

  }

  onRedoSampleClick() {
    this.blocked = true;
    this.apgAdminService.updateRedoSample(this.selectedLabId, this.batchID, this.sampleInfo.barcode, this.sampleInfo.unboxedSender, true).subscribe(
      results => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: results.data });
      },
      error => {
        this.blocked = false;
        this.showError(error);
      }
    );
  }


  loadFalconSample(searchID: string) {

  }
  loadBagIdSample(searchID: string) {

  }
  loadBoxIdSample(searchID: string) {

  }
  loadBagIdSampleDetails(searchID: string) {

  }
  loadFalconIdSampleDetails(searchID: string) {

  }
  getRecvDate(date: any) {
    if (date) {
      return date['$date'];
    } else {
      return null;
    }
  }

  openEditUnwrappedSamplePopup() {
    this.editUnwrappedSamplePopup = true;
    this.updatedDepoolingRetestDTO = new Falcon();
    this.updatedDepoolingRetestDTO.boxID = this.depoolingRetestDTO.boxID;
    this.updatedDepoolingRetestDTO.bagID = this.depoolingRetestDTO.bagID;
    this.updatedDepoolingRetestDTO.schoolID = this.depoolingRetestDTO.schoolID;
    this.updatedDepoolingRetestDTO.falconID = this.depoolingRetestDTO.falconID;
  }

  disableEditUnwrappedEntry() {
    return (!this.updatedDepoolingRetestDTO || !this.updatedDepoolingRetestDTO.boxID || this.updatedDepoolingRetestDTO.boxID === '' || !this.updatedDepoolingRetestDTO.bagID || this.updatedDepoolingRetestDTO.bagID === ''
      || !this.updatedDepoolingRetestDTO.falconID || this.updatedDepoolingRetestDTO.falconID === '' || !this.updatedDepoolingRetestDTO.schoolID || this.updatedDepoolingRetestDTO.schoolID === '');
  }

  updateUnwrappedEntry() {
    this.blocked = true;
    this.apgAdminService.editExistingFalcon(this.selectedLabId, this.depoolingRetestDTO.boxID, this.depoolingRetestDTO.falconID, this.updatedDepoolingRetestDTO).subscribe(
      response => {
        this.editUnwrappedSamplePopup = false;
        this.depoolingRetestDTO.bagID = response.bagID;
        this.depoolingRetestDTO.schoolID = response.schoolID;
        this.depoolingRetestDTO.falconID = response.falconID;
        this.depoolingRetestDTO.lastModifiedBy = response.lastModifiedBy;
        this.depoolingRetestDTO.lastModifiedDate = { "$date": response.lastModifiedDate };
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Unwrapped entry is updated!',
          detail: 'Falcon ' + this.depoolingRetestDTO.falconID + ' is updated as requested'
        })
      }, error => {
        this.blocked = false;
        if (error)
          this._messagesService.addErrorMessage(this.errorHandler.handleError(error));
        else {
          this._messagesService.addErrorMessage({
            severity: "error", summary: "Unable to update",
            detail: "Something is wrong, failed to update. Please try again... If this still persists, please reach out to Support for assistance"
          })
        }
      }
    )
  }
  disableAdmin() {
    return (!this.validRole)
  }

}
